var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimForSureLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ClaimForSure_logo-01",
    "data-name": "ClaimForSure logo-01",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.305,
    height: 20.912,
    viewBox: "0 0 88.305 20.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M84.557,21.5H6.267A4.29,4.29,0,0,1,2,17.2V6.3A4.32,4.32,0,0,1,6.3,2h78.29a4.32,4.32,0,0,1,4.3,4.3V17.2A4.327,4.327,0,0,1,84.557,21.5Z",
    transform: "translate(-1.295 -1.295)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M83.262,20.912H4.972A5,5,0,0,1,0,15.9V5.008A5.027,5.027,0,0,1,5.008,0H83.3A5.027,5.027,0,0,1,88.3,5.008V15.9A5.034,5.034,0,0,1,83.262,20.912ZM5.008,1.411a3.612,3.612,0,0,0-3.6,3.6V15.9a3.612,3.612,0,0,0,3.6,3.6H83.3a3.612,3.612,0,0,0,3.6-3.6V5.008a3.612,3.612,0,0,0-3.6-3.6Z",
    transform: "translate(0 0)",
    fill: "#053c6d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(6.983 6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M23.926,27.134a4.5,4.5,0,0,1-2.222-.529,3.571,3.571,0,0,1-1.411-1.481,5.406,5.406,0,0,1,0-4.514A3.571,3.571,0,0,1,21.7,19.129a4.317,4.317,0,0,1,2.222-.529,4.344,4.344,0,0,1,1.552.247,3.8,3.8,0,0,1,1.2.741l-.458,1.234a4.209,4.209,0,0,0-1.058-.635A3.1,3.1,0,0,0,24,20.011a2.371,2.371,0,0,0-1.9.741,3.267,3.267,0,0,0-.67,2.151,3.086,3.086,0,0,0,.67,2.151,2.44,2.44,0,0,0,1.9.776,4.027,4.027,0,0,0,1.164-.176,4.21,4.21,0,0,0,1.058-.635l.494,1.2a3.8,3.8,0,0,1-1.2.741A7.037,7.037,0,0,1,23.926,27.134Z",
    transform: "translate(-19.8 -18.424)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M43.1,26.7V18.1h1.446v8.6Z",
    transform: "translate(-34.883 -18.1)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M53.474,31.536a2.379,2.379,0,0,1-1.34-.353,2.453,2.453,0,0,1-.917-1.058,4.487,4.487,0,0,1,0-3.315A2.359,2.359,0,0,1,53.474,25.4a2.262,2.262,0,0,1,1.3.353,1.594,1.594,0,0,1,.741.987h-.141l.141-1.234H56.93c-.035.247-.035.494-.071.741a5.209,5.209,0,0,0-.035.741V31.43H55.379V30.2h.141a1.921,1.921,0,0,1-.776.987A2.148,2.148,0,0,1,53.474,31.536Zm.388-1.128a1.466,1.466,0,0,0,1.128-.494,2.185,2.185,0,0,0,.423-1.481,2.083,2.083,0,0,0-.423-1.446,1.415,1.415,0,0,0-1.128-.494,1.466,1.466,0,0,0-1.128.494,2.145,2.145,0,0,0-.423,1.446,2.314,2.314,0,0,0,.423,1.481A1.4,1.4,0,0,0,53.862,30.408Z",
    transform: "translate(-39.932 -22.826)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M72.1,20.011V18.6h1.622v1.411Zm.071,7.018V21.1h1.446v5.925Z",
    transform: "translate(-53.656 -18.424)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M80.706,31.366V26.922a5.208,5.208,0,0,0-.035-.741,5.262,5.262,0,0,0-.071-.741h1.411l.141,1.164h-.141a2.487,2.487,0,0,1,.741-.952,2.278,2.278,0,0,1,1.2-.353,2.051,2.051,0,0,1,1.164.317,1.611,1.611,0,0,1,.635,1.023h-.176a2.028,2.028,0,0,1,.811-.987,2.3,2.3,0,0,1,1.27-.353,1.811,1.811,0,0,1,1.481.6,2.85,2.85,0,0,1,.494,1.834v3.632H88.182V27.8a1.621,1.621,0,0,0-.247-1.023.865.865,0,0,0-.741-.317,1.114,1.114,0,0,0-.952.423,1.7,1.7,0,0,0-.353,1.164v3.315H84.444V27.8a1.621,1.621,0,0,0-.247-1.023.865.865,0,0,0-.741-.317,1.114,1.114,0,0,0-.952.423,1.7,1.7,0,0,0-.353,1.164v3.315Z",
    transform: "translate(-59.159 -22.761)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M111.1,27.352V19.1h5.431v1.2h-3.914v2.328h3.668v1.2h-3.668v3.562H111.1Z",
    transform: "translate(-78.903 -18.747)",
    fill: "#e77817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M131.262,31.536a3.3,3.3,0,0,1-1.587-.388,2.468,2.468,0,0,1-1.023-1.058,3.907,3.907,0,0,1,0-3.244,2.686,2.686,0,0,1,1.023-1.058,3.44,3.44,0,0,1,3.174,0,2.55,2.55,0,0,1,1.058,1.058,3.907,3.907,0,0,1,0,3.244,2.55,2.55,0,0,1-1.058,1.058A2.947,2.947,0,0,1,131.262,31.536Zm0-1.128a1.393,1.393,0,0,0,1.093-.494,2.185,2.185,0,0,0,.423-1.481,2.083,2.083,0,0,0-.423-1.446,1.457,1.457,0,0,0-2.186,0,2.145,2.145,0,0,0-.423,1.446,2.314,2.314,0,0,0,.423,1.481A1.291,1.291,0,0,0,131.262,30.408Z",
    transform: "translate(-90.037 -22.826)",
    fill: "#e77817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M148.671,31.43V26.246a4.8,4.8,0,0,0-.071-.741h1.411l.176,1.622h-.247a2.756,2.756,0,0,1,.388-.987,1.7,1.7,0,0,1,.67-.564,1.882,1.882,0,0,1,.882-.176h.353a.654.654,0,0,1,.247.071v1.27a.919.919,0,0,0-.388-.106c-.106,0-.247-.035-.388-.035a1.5,1.5,0,0,0-.846.212,1.455,1.455,0,0,0-.529.6,2.131,2.131,0,0,0-.176.846V31.4h-1.481Z",
    transform: "translate(-103.178 -22.826)",
    fill: "#e77817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M164.28,27.07a6.072,6.072,0,0,1-1.834-.247A4.6,4.6,0,0,1,161,26.117l.458-1.2a4.863,4.863,0,0,0,1.763.741,4.886,4.886,0,0,0,1.058.106,2.274,2.274,0,0,0,1.34-.317.944.944,0,0,0,.423-.811.9.9,0,0,0-.282-.67,2.665,2.665,0,0,0-1.023-.388l-1.3-.282a3.441,3.441,0,0,1-1.693-.776,1.89,1.89,0,0,1-.564-1.481,2.17,2.17,0,0,1,.423-1.34,2.7,2.7,0,0,1,1.164-.882,4.319,4.319,0,0,1,1.728-.317,4.748,4.748,0,0,1,1.622.247,3.779,3.779,0,0,1,1.234.705l-.458,1.128a3.838,3.838,0,0,0-1.093-.635,3.958,3.958,0,0,0-1.34-.212,2.3,2.3,0,0,0-1.3.317,1.053,1.053,0,0,0-.176,1.587,1.854,1.854,0,0,0,.987.388l1.3.247a3.428,3.428,0,0,1,1.728.776,1.862,1.862,0,0,1,.564,1.446,2.365,2.365,0,0,1-.388,1.3,2.587,2.587,0,0,1-1.128.882A4.477,4.477,0,0,1,164.28,27.07Z",
    transform: "translate(-111.205 -18.359)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M185.351,31.666a2.076,2.076,0,0,1-1.622-.6,2.711,2.711,0,0,1-.529-1.834v-3.6h1.446v3.6a1.394,1.394,0,0,0,.282.952,1.012,1.012,0,0,0,.811.317,1.357,1.357,0,0,0,1.023-.423,1.619,1.619,0,0,0,.388-1.128V25.6H188.6v5.925h-1.411v-1.2h.176a2.06,2.06,0,0,1-2.01,1.34Z",
    transform: "translate(-125.576 -22.955)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M202.871,31.43V26.246a4.8,4.8,0,0,0-.071-.741h1.411l.176,1.622h-.247a2.756,2.756,0,0,1,.388-.987,1.7,1.7,0,0,1,.67-.564,1.883,1.883,0,0,1,.882-.176h.353a.654.654,0,0,1,.247.071v1.27a.919.919,0,0,0-.388-.106c-.106,0-.247-.035-.388-.035a1.5,1.5,0,0,0-.846.212,1.455,1.455,0,0,0-.529.6,2.131,2.131,0,0,0-.176.846V31.4h-1.481Z",
    transform: "translate(-138.264 -22.826)",
    fill: "#053c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M218.074,31.471a3.276,3.276,0,0,1-2.328-.811A2.978,2.978,0,0,1,214.9,28.4a3.433,3.433,0,0,1,.353-1.622,2.768,2.768,0,0,1,1.023-1.093,3.027,3.027,0,0,1,1.516-.388,2.465,2.465,0,0,1,1.411.353,2.287,2.287,0,0,1,.882,1.023,3.428,3.428,0,0,1,.282,1.516v.388h-4.3V27.8h3.28l-.212.176a2.009,2.009,0,0,0-.353-1.27,1.23,1.23,0,0,0-.987-.423,1.342,1.342,0,0,0-1.128.529,2.431,2.431,0,0,0-.388,1.446V28.4a1.981,1.981,0,0,0,.458,1.446,1.822,1.822,0,0,0,1.34.458,2.832,2.832,0,0,0,.952-.141,4.74,4.74,0,0,0,.846-.423l.423.987a3.478,3.478,0,0,1-1.023.529A3.294,3.294,0,0,1,218.074,31.471Z",
    transform: "translate(-146.097 -22.761)",
    fill: "#053c6d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimForSureLogo);
export default __webpack_public_path__ + "static/media/ClaimForSureLogo.f5348e40d6cba4b0692ca77c90c66f0e.svg";
export { ForwardRef as ReactComponent };